<template>
  <div class="standard-page">
    <div class="detail-view-header">Customer Detail</div>
    <div class="detail-view-deck">
      <b-card class="detail-view-info-card">
        <LabeledInfo label="First Name" :value="customer.first_name" />
        <LabeledInfo label="Last Name" :value="customer.last_name" />
        <LabeledInfo
          label="Phone Number"
          :value="customer.sms_phone_number"
          type="phone"
        />
        <LabeledInfo label="Email" :value="customer.email" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="Address" :value="customer.address" />
        <LabeledInfo label="Address ln 2" :value="customer.address2" />
        <LabeledInfo label="City" :value="customer.city" />
        <LabeledInfo label="Postal Code" :value="customer.postal_code" />
        <LabeledInfo label="State/Province" :value="customer.state_province" />
        <LabeledInfo label="Country" :value="customer.country" />
      </b-card>
      <b-card class="detail-view-info-card">
        <LabeledInfo label="ID" :value="customer.id" />
        <LabeledInfo label="External ID" :value="customer.external_id" />
      </b-card>
      <div class="detail-view-header">Accounts</div>
      <b-card
        v-for="account in customer.accounts"
        class="detail-view-info-card"
        v-bind:key="account.id"
      >
        <LabeledInfo label="Account ID" :value="account.external_id" />
        <LabeledInfo label="Amount Due" :value="account.amount_due" />
        <LabeledInfo label="Due Date" :value="account.due_date" />
      </b-card>
      <div class="detail-view-header">Messages</div>
      <b-card
        v-for="message in messages"
        class="detail-view-info-card"
        v-bind:key="message.id"
      >
        <LabeledInfo label="Sent on" :value="message.created" />
        <LabeledInfo label="To" :value="message.to_number" />
        <LabeledInfo label="Body" :value="message.body" />
        <LabeledInfo label="Status" :value="message.status" />
      </b-card>
    </div>
  </div>
</template>

<script>
import endpoints from '@/utils/endpoints.js'

export default {
  data() {
    return {
      customer: {
        accounts: []
      },
      messages: []
    }
  },
  mounted() {
    this.getCustomer()
    this.getMessages()
  },
  methods: {
    getCustomer() {
      this.axios
        .get(
          endpoints.retrieveCustomer(
            this.$route.params.merchantID,
            this.$route.params.customerID
          )
        )
        .then(res => {
          this.customer = res.data
        })
        .catch(err => {
          console.log('error', err)
        })
    },
    getMessages() {
      this.axios
        .get(
          endpoints.listCustomerMessages(
            this.$route.params.merchantID,
            this.$route.params.customerID
          )
        )
        .then(res => {
          this.messages = res.data.results
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>
